import { environment } from 'env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class LicenseService {
  constructor(public http: HttpClient) {
  }

  requestLicenses(schoolId: number, data: { count: number, beginsAt: string, endsAt: string }) {
    return this.http.post(environment.baseURL + `/api/admin/schools/${schoolId}/requestLicense`, data);
  }
}
